
<!-- Target ID is in chat-component.html line 66 -->
<div
    class="emoji-button" 
    (click)="showEmojiPicker()" >
    <i class="fas fa-laugh-beam"></i>
</div>